import {
  PRACTICE_IMPULSE_TRIGGERS,
  getPracticeImpulseMessages,
} from '../data/cosmicPracticeImpulseMessages';

// Motor temporal por sesión. No escribe en storage ni conoce puntuación,
// progreso, desbloqueos o escenas de Competencia.
export class PracticeImpulseEngine {
  constructor({ world = 'suma', maxPerSession = 2, cooldownMs = 3 * 60 * 1000 } = {}) {
    this.world = world;
    this.maxPerSession = maxPerSession;
    this.cooldownMs = cooldownMs;
    this.shownCount = 0;
    this.lastShownAt = null;
    this.errorCount = 0;
    this.errorsSinceLastCorrect = 0;
    this.correctStreak = 0;
    this.streakAwarded = false;
    this.tutorialCompleted = false;
    this.skipNextPositiveOutcome = false;
    this.lastMessageIdByTrigger = Object.create(null);
  }

  recordIncorrect() {
    this.errorCount += 1;
    this.errorsSinceLastCorrect += 1;
    this.correctStreak = 0;
    this.streakAwarded = false;
    this.skipNextPositiveOutcome = false;
  }

  markTutorialCompleted() {
    this.tutorialCompleted = true;
  }

  evaluateCorrect(nowMs) {
    const wasBlockedAfterImpulse = this.skipNextPositiveOutcome;
    this.skipNextPositiveOutcome = false;
    this.correctStreak += 1;

    const hasTutorialLearning = this.tutorialCompleted;
    const hadErrorsBeforeCorrect = this.errorsSinceLastCorrect > 0;
    const hasPersistence = this.errorCount >= 3;
    const hasNewStreak = this.correctStreak === 5 && !this.streakAwarded;
    if (hasNewStreak) this.streakAwarded = true;

    this.tutorialCompleted = false;
    this.errorsSinceLastCorrect = 0;

    if (wasBlockedAfterImpulse) return null;

    const trigger = hasTutorialLearning
      ? PRACTICE_IMPULSE_TRIGGERS.TUTORIAL_LEARNING
      : hadErrorsBeforeCorrect
        ? PRACTICE_IMPULSE_TRIGGERS.RECOVERY
        : hasPersistence
          ? PRACTICE_IMPULSE_TRIGGERS.PERSISTENCE
          : hasNewStreak
            ? PRACTICE_IMPULSE_TRIGGERS.STREAK
            : null;

    if (!trigger || !this.canShow(trigger, nowMs)) return null;
    return { trigger, message: this.nextMessage(trigger) };
  }

  canShow(trigger, nowMs) {
    if (this.shownCount >= this.maxPerSession) return false;
    // El primer refuerzo válido aparece de inmediato: así el piloto puede
    // reconocer Recuperación, Racha, Persistencia o Aprendizaje real. A partir
    // del segundo se aplica el intervalo completo para evitar spam.
    if (this.shownCount === 0) return true;
    return this.lastShownAt === null || nowMs - this.lastShownAt >= this.cooldownMs;
  }

  registerShown(nowMs) {
    this.shownCount += 1;
    this.lastShownAt = nowMs;
    // Impide que dos ejercicios consecutivos muestren tarjetas, aunque el
    // tiempo de sesión sea manipulado durante pruebas.
    this.skipNextPositiveOutcome = true;
  }

  nextMessage(trigger) {
    const messages = getPracticeImpulseMessages(this.world, trigger);
    if (!messages.length) return null;
    const previousId = this.lastMessageIdByTrigger[trigger];
    const alternatives = messages.filter(message => message.id !== previousId);
    const pool = alternatives.length ? alternatives : messages;
    const message = pool[Math.floor(Math.random() * pool.length)];
    this.lastMessageIdByTrigger[trigger] = message.id;
    return message;
  }
}
